import HttpClientToken from '../../services/HttpClientToken';

import { defaultFormaNotificacion, FormaNotificacionProps } from '../../interfaces/catalogos/FormaNotificacionInterface';

export const FormaNotificacion = () => {

    return new Promise<FormaNotificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/FormaNotificacion/', token)
            .then( ({ data } : { data : FormaNotificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerFormaNotificacion = () => {

    return new Promise<FormaNotificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/FormaNotificacion/ObtenerFormaNotificacion', token)
            .then( ({ data } : { data : FormaNotificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarFormaNotificacion = ( params: FormaNotificacionProps ) => {

    return new Promise<FormaNotificacionProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/FormaNotificacion/Actualizar', params, token)
            .then( ({ data } : { data : FormaNotificacionProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultFormaNotificacion } );
            });

        }

    });

}

export const AgregarFormaNotificacion = ( params: FormaNotificacionProps ) => {

    return new Promise<FormaNotificacionProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/FormaNotificacion/Agregar', params, token)
            .then( ({ data } : { data : FormaNotificacionProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultFormaNotificacion } );
            });

        }

    });

}
